import {
  DUPLICATE_DMX_DEVICE_PRESETS,
  DUPLICATE_DMX_DEVICE_PRESETS_SUCCESSFUL,
  DUPLICATE_DMX_DEVICE_PRESETS_FAILED,
} from './actionTypes';

export const duplicateDmxDevicePresets = (request) => {
  return {
    type: DUPLICATE_DMX_DEVICE_PRESETS,
    payload: { request },
  };
};

export const duplicateDmxDevicePresetsSuccessful = (response) => {
  return {
    type: DUPLICATE_DMX_DEVICE_PRESETS_SUCCESSFUL,
    payload: response,
  };
};

export const duplicateDmxDevicePresetsFailed = (message) => {
  return {
    type: DUPLICATE_DMX_DEVICE_PRESETS_FAILED,
    payload: message,
  };
};
